import styled from 'styled-components';
import Finance from '../../components/ui/organisms/academic/Finance';
import { useEffect } from 'react';
import { financesActions } from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';

const FinancialStatement = () => {
    const dispatch = useDispatch();
    const finances = useSelector((state) => state.finances.finances);

    // EFFECTS
    useEffect(() => {
        if (finances === null) {
            dispatch(financesActions.getFinancesRequest());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container>
            <Finance />
        </Container>
    );
};

export default FinancialStatement;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    padding: 1rem;
    box-sizing: border-box;
`;
